import { CART_RECEIVE, CART_SHOW_INFO, CART_SORT } from '../Actions/Cart.action';

export const cart = (state = { quantity: 0, orderTotal: 0, showInfo: false, sortCriteria: [], selectedSort: 'LastAdded'}, action) => {
    switch (action.type) {
        case CART_RECEIVE:
        case CART_SHOW_INFO:
        case CART_SORT:
            return {
                ...state,
                ...action.payload,
            };
        default:
            return state;
    }
}